// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d586b96b","488":"2d89c602","977":"d2b75470"}[chunkId] + ".chunk.js";
};